export default __webpack_public_path__ + "static/media/section-06-bg.620fb4bc.jpg";